(() => {
  const popup = document.getElementById('BlankabricNewsletterPopup');
  if (!(popup instanceof HTMLDialogElement)) return;

  const storage = {
    get(key) {
      try {
        return window.localStorage.getItem(key);
      } catch {
        return null;
      }
    },
    set(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch {}
    },
  };
  const sessionStorage = {
    get(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch {
        return null;
      }
    },
    set(key, value) {
      try {
        window.sessionStorage.setItem(key, value);
      } catch {}
    },
    remove(key) {
      try {
        window.sessionStorage.removeItem(key);
      } catch {}
    },
  };
  const claimedKey = 'blankabric-newsletter-claimed-v3';
  const dismissedKey = 'blankabric-newsletter-dismissed-v3';
  const browsingTimeKey = 'blankabric-newsletter-visible-time-v1';
  const minimumDisplayDelay = 45000;
  const requestedDisplayDelay = Number(popup.dataset.displayDelayMs);
  const displayDelay = Number.isFinite(requestedDisplayDelay)
    ? Math.max(minimumDisplayDelay, requestedDisplayDelay)
    : minimumDisplayDelay;
  const dismissedAt = Number(storage.get(dismissedKey) || 0);
  const dismissalDuration = 3 * 24 * 60 * 60 * 1000;
  // Prior dismissal or subscription suppresses automatic offers, never an explicit signup request.
  const suppressAutomaticPopup = Boolean(storage.get(claimedKey) || (dismissedAt && Date.now() - dismissedAt < dismissalDuration));

  const form = popup.querySelector('[data-bb-newsletter-form]');
  const formState = popup.querySelector('[data-bb-newsletter-form-state]');
  const successState = popup.querySelector('[data-bb-newsletter-success]');
  const submitButton = popup.querySelector('[data-bb-newsletter-submit]');
  const loadingLabel = popup.querySelector('[data-bb-newsletter-loading]');
  const errorMessage = popup.querySelector('[data-bb-newsletter-error]');
  const codeLabel = popup.querySelector('[data-bb-newsletter-code]');
  const codeRow = popup.querySelector('.bb-newsletter-popup__code-row');
  const copyButton = popup.querySelector('[data-bb-newsletter-copy]');
  const statusMessage = popup.querySelector('[data-bb-newsletter-status]');
  const expiryMessage = popup.querySelector('[data-bb-newsletter-expiry]');
  const shopLink = popup.querySelector('[data-bb-newsletter-shop]');
  const offerPercent = popup.querySelector('[data-bb-offer-percent]');
  let channel = 'whatsapp';
  let completed = false;
  let renderedAt = Date.now();
  let opener = null;

  const setChannel = (nextChannel) => {
    channel = nextChannel === 'email' ? 'email' : 'whatsapp';
    popup.querySelectorAll('[data-bb-newsletter-channel]').forEach((button) => {
      const selected = button.getAttribute('data-bb-newsletter-channel') === channel;
      button.setAttribute('aria-selected', String(selected));
      button.setAttribute('tabindex', selected ? '0' : '-1');
    });
    popup.querySelectorAll('[data-bb-channel-panel]').forEach((panel) => {
      const active = panel.getAttribute('data-bb-channel-panel') === channel;
      panel.hidden = !active;
      panel.querySelectorAll('input').forEach((input) => {
        input.required = active;
      });
    });
    popup.querySelectorAll('[data-bb-consent-copy]').forEach((copy) => {
      copy.hidden = copy.getAttribute('data-bb-consent-copy') !== channel;
    });
    popup.querySelectorAll('[data-bb-submit-label]').forEach((label) => {
      label.hidden = label.getAttribute('data-bb-submit-label') !== channel;
    });
    if (offerPercent) offerPercent.textContent = channel === 'whatsapp' ? '15' : '5';
    popup.querySelectorAll('[data-bb-whatsapp-exclusion]').forEach((element) => {
      element.hidden = channel !== 'whatsapp';
    });
    if (errorMessage) errorMessage.hidden = true;
  };

  setChannel(channel);
  popup.querySelectorAll('[data-bb-newsletter-channel]').forEach((button) => {
    button.addEventListener('click', () => {
      setChannel(button.getAttribute('data-bb-newsletter-channel'));
      popup.querySelector(`[data-bb-channel-panel="${channel}"] input`)?.focus();
    });
  });

  const close = () => popup.close();
  popup.querySelectorAll('[data-bb-newsletter-close]').forEach((button) => button.addEventListener('click', close));
  popup.addEventListener('click', (event) => {
    const bounds = popup.getBoundingClientRect();
    const outside =
      event.clientX < bounds.left ||
      event.clientX > bounds.right ||
      event.clientY < bounds.top ||
      event.clientY > bounds.bottom;
    if (outside) close();
  });
  popup.addEventListener('close', () => {
    if (!completed) storage.set(dismissedKey, String(Date.now()));
    if (opener?.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  });

  let visibleTime = Math.max(0, Number(sessionStorage.get(browsingTimeKey)) || 0);
  let visibleSince = document.visibilityState === 'visible' ? Date.now() : null;
  let displayTimer;
  let hasOpened = false;

  const saveVisibleTime = () => {
    if (hasOpened) return;
    if (visibleSince !== null) {
      visibleTime += Math.max(0, Date.now() - visibleSince);
      visibleSince = Date.now();
    }
    sessionStorage.set(browsingTimeKey, String(visibleTime));
  };

  const clearDisplayTimer = () => {
    if (displayTimer !== undefined) {
      window.clearTimeout(displayTimer);
      displayTimer = undefined;
    }
  };

  const openPopup = ({ manual = false, trigger = null } = {}) => {
    saveVisibleTime();
    if (popup.open || (!manual && (suppressAutomaticPopup || hasOpened || visibleTime < displayDelay))) return;
    if (manual) {
      opener = trigger;
      // Reopening after a successful signup allows subscribing to the other channel.
      // An in-flight submission keeps its channel and state until its response arrives.
      if (!submitButton?.disabled) {
        completed = false;
        if (formState) formState.hidden = false;
        if (successState) successState.hidden = true;
        const consent = form?.querySelector('[name="marketing_consent"]');
        if (consent) consent.checked = false;
        setChannel(trigger?.dataset.bbNewsletterOpen || channel);
      }
    }
    clearDisplayTimer();
    hasOpened = true;
    sessionStorage.remove(browsingTimeKey);
    renderedAt = Date.now();
    popup.showModal();
    // Keep the initial focus on the close button on mobile to avoid opening the keyboard.
    if (window.matchMedia('(min-width: 721px)').matches) {
      window.setTimeout(() => {
        if (popup.open && document.activeElement?.matches('[data-bb-newsletter-close]')) {
          popup.querySelector(`[data-bb-channel-panel="${channel}"] input`)?.focus({ preventScroll: true });
        }
      }, 450);
    }
  };

  const schedulePopup = () => {
    clearDisplayTimer();
    if (suppressAutomaticPopup || hasOpened || document.visibilityState !== 'visible') return;
    saveVisibleTime();
    displayTimer = window.setTimeout(() => openPopup(), Math.max(0, displayDelay - visibleTime));
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-bb-newsletter-open]') : null;
    if (!trigger) return;
    event.preventDefault();
    openPopup({ manual: true, trigger });
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      visibleSince = Date.now();
      schedulePopup();
      return;
    }

    saveVisibleTime();
    visibleSince = null;
    clearDisplayTimer();
  });

  window.addEventListener('pagehide', () => {
    saveVisibleTime();
    clearDisplayTimer();
  });

  schedulePopup();

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!(form instanceof HTMLFormElement) || !form.reportValidity()) return;

    const data = new FormData(form);
    submitButton?.setAttribute('disabled', '');
    popup.querySelectorAll('[data-bb-submit-label]').forEach((label) => {
      label.hidden = true;
    });
    if (loadingLabel) loadingLabel.hidden = false;
    if (errorMessage) errorMessage.hidden = true;

    try {
      const response = await fetch('/apps/blankabric-wishlist/newsletter-discount', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          channel,
          email: channel === 'email' ? data.get('email') : data.get('whatsapp_email'),
          phone: channel === 'whatsapp' ? data.get('phone') : undefined,
          company: data.get('company'),
          locale: popup.dataset.locale || document.documentElement.lang || 'fr',
          marketing_consent: data.get('marketing_consent') === 'on',
          rendered_at: renderedAt,
        }),
      });
      const result = await response.json().catch(() => null);
      if (!response.ok || !result?.code) {
        const error = new Error(result?.error || 'newsletter_discount_failed');
        error.code = result?.error;
        throw error;
      }

      const code = String(result.code).toUpperCase();
      const unavailable = result.redeemed === true || result.expired === true;
      completed = true;
      storage.set(claimedKey, 'true');
      if (formState) formState.hidden = true;
      if (successState) successState.hidden = false;
      popup.querySelectorAll('[data-bb-success-copy]').forEach((copy) => {
        copy.hidden = copy.getAttribute('data-bb-success-copy') !== channel;
      });
      if (codeLabel) codeLabel.textContent = code;
      if (codeRow) codeRow.hidden = unavailable || channel === 'whatsapp';
      if (statusMessage) {
        statusMessage.textContent = result.redeemed === true
          ? popup.dataset.redeemedMessage || ''
          : result.expired === true
            ? popup.dataset.expiredMessage || ''
            : '';
        statusMessage.hidden = !statusMessage.textContent;
      }
      if (expiryMessage) expiryMessage.hidden = unavailable || channel === 'whatsapp' || !result.expires_at;
      if (shopLink instanceof HTMLAnchorElement) {
        const root = popup.dataset.rootUrl || '';
        shopLink.href = unavailable
          ? `${root}/collections/all`
          : `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${root}/collections/all`)}`;
      }
      (unavailable || channel === 'whatsapp' ? shopLink : copyButton)?.focus();
    } catch (error) {
      if (errorMessage) {
        errorMessage.textContent = error?.code === 'customer_identity_conflict'
          ? popup.dataset.identityErrorMessage || popup.dataset.errorMessage || ''
          : popup.dataset.errorMessage || '';
        errorMessage.hidden = false;
      }
    } finally {
      submitButton?.removeAttribute('disabled');
      popup.querySelectorAll('[data-bb-submit-label]').forEach((label) => {
        label.hidden = label.getAttribute('data-bb-submit-label') !== channel;
      });
      if (loadingLabel) loadingLabel.hidden = true;
    }
  });

  copyButton?.addEventListener('click', async () => {
    const code = codeLabel?.textContent || '';
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
      copyButton.textContent = popup.dataset.copiedLabel || copyButton.textContent;
    } catch {}
  });
})();
